<template>
    <div class="frame-wrapper" :class="{pad10:withPadding}">
        <iframe ref="innerFrame" v-if="iframeSrc" :src="iframeSrc" frameborder="0" />
        <p v-else>
            嵌入错误
        </p>
    </div>
</template>
<script>
    export default {
      props: {
        src: {
          type: String,
          required: false,
          validator: function(val) {
            if (!val || !val.trim().length) {
              return false;
            }
            return true;
          }
        }
      },
      data: function() {
        return {
          metaSrc: null,
          withPadding: false,
          isFrameLoading: false,
          loadingWidth: 0
        };
      },
      created() {
        let route = this.$route;
        this.updateMetaSrc(route);
        this.unregisterRouteHookFn = this.$router.beforeEach((to, from, next) => {
          this.updateMetaSrc(to);
          next();
        });
      },
      methods: {
        updateMetaSrc(route) {
          if (route.meta) {
            if (route.meta.src) {
              this.metaSrc = route.meta.src;
            }
            this.withPadding = route.meta.withPadding;
          }
        }
      },
      destroyed() {
        if (this.unregisterRouteHookFn) {
          this.unregisterRouteHookFn();
        }
      },
      computed: {
        iframeSrc() {
          let src = this.src || this.metaSrc;
          if (src) {
            src = src.replace(".html/#", ".html#");
          }
          return src;
        }
      }
    };
</script>
<style rel="stylesheet/css" lang="postcss" scoped type="text/postcss">
.frame-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: hidden;
  &.pad10 {
    padding: 10px;
  }
  iframe {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
  }
}
</style>





// WEBPACK FOOTER //
// inner-frame.vue?43fad096